import React from 'react'
import Box from '@amzn/meridian/box'
import Text from '@amzn/meridian/text'
import { IViewOnlyNoticeProps } from '../types'
import { VIEW_ONLY_TITLE, VIEW_ONLY_MESSAGE } from '../constants'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './ViewOnlyNotice.scss'

/**
 * ViewOnlyNotice Component
 *
 * Displays an informational notice indicating that notifications are view-only.
 * Shown when viewing notifications for stores other than the current store.
 */
export const ViewOnlyNotice: React.FC<IViewOnlyNoticeProps> = ({ visible }) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    if (!visible) {
        return null
    }

    return (
        <Box type="outline" width="100%" spacingInset="300 450" className="view-only-notice" data-testid="view-only-notice">
            <span className="italic-text">
                <Text type="h100" alignment="left">
                    {t(bundle, VIEW_ONLY_TITLE)}
                </Text>
            </span>
            <span className="italic-text">
                <Text type="b300" alignment="left">
                    {t(bundle, VIEW_ONLY_MESSAGE)}
                </Text>
            </span>
        </Box>
    )
}
